/**
 * Share glyph (upward arrow out of an open tray) used by the per-message
 * share action. Uses `currentColor` so the enclosing button controls every
 * interaction-state tint.
 *
 * The path data is transcribed directly from the GA-Sidekick Figma
 * `share-01` vector inside the `response actions` component. It is drawn on
 * the same 24x24 grid and 1.5 stroke as the sibling action glyphs, so all of
 * them render at one stroke weight when scaled to the same size.
 */
export type ShareGlyphProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function ShareGlyph({ size = 24, className }: ShareGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 7L12 3L16 7M12 3V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ShareGlyph;
